import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export function IntroSection() {
  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xl md:text-2xl text-foreground/90 leading-relaxed mb-6">
            Ready to transform your backyard into a space you actually enjoy? Thinking about a paver patio, outdoor kitchen, or fire pit?
          </p>
          
          <p className="text-lg text-muted-foreground leading-relaxed mb-6">
            You're not alone. A lot of homeowners in North Jersey have been sitting on a project for years. They know what they want but haven't found the right masonry contractor to make it happen.
          </p>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
            If you've got a project in mind, call or text us at{" "}
            <a href="tel:+19737252395" className="text-secondary hover:text-secondary/80 font-semibold">
              (973) 725-2395
            </a>
            . We'll come take a look and talk through what's possible.
          </p>
        </div>
      </div>
    </section>
  );
}
